var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('foldSide',_vm._g(_vm._b({attrs:{"logo":_vm.logo}},'foldSide',_vm.headerInfo,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }